.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.toolbar {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
}

.toolbarLeft {
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 16px;
  min-width: 0;
}

.toolbarRight {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.searchInput {
  max-width: 320px;
  min-width: 120px;
  width: 100%;
}

.rowActions {
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.itineraryLink {
  color: var(--color-primary, #2563eb);
  font-weight: 500;
  text-decoration: none;
}

.itineraryLink:hover {
  text-decoration: underline;
}

.expireSoon {
  color: var(--color-warning, #f59e0b);
}

.expirePast {
  color: var(--color-destructive, #ef4444);
}

.paginationRow {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
}

.pageSize {
  align-items: center;
  display: flex;
  gap: 8px;
}

.pageNav {
  align-items: center;
  display: flex;
  gap: 12px;
}
